// Shared constants and helpers for the Admin Warehouse module
import { useState, useEffect } from "react";
import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const authHeaders = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem("mv_admin_token")}` },
});

// Tariffe magazzino del cliente (listino personalizzato → contratto → default)
export function useWarehousePriceHints(clientEmail) {
  const [hints, setHints] = useState(null);
  useEffect(() => {
    if (!clientEmail) { setHints(null); return; }
    let alive = true;
    axios
      .get(`${API}/admin/warehouse/price-hints?client_email=${encodeURIComponent(clientEmail)}`, authHeaders())
      .then((r) => { if (alive) setHints(r.data); })
      .catch(() => { if (alive) setHints(null); });
    return () => { alive = false; };
  }, [clientEmail]);
  return hints;
}

export const SOURCE_LABELS = {
  listino: "listino cliente",
  contratto: "contratto",
  default: "default",
  nessuna: "nessuna tariffa",
};
